import {channelsFiltersSchema} from './constants/channels';

/**
 * Customize the filter options so that they include all the possible options based on the available data
 *
 * @param {Object[]} channelsList - the list of channels to use for customizing the filters
 * @returns {Object} the customized schema
 */
const getCustomizedFilterSchema = channelsList => {
    const customOptions = {paymentProviderName: [], paymentMethodName: []};
    const schema = {...channelsFiltersSchema};

    channelsList.forEach(channel => {
        // If the current custom options don't yet have this provider's name, add it
        if (!customOptions.paymentProviderName.includes(channel.payment_provider.name)) {
            customOptions.paymentProviderName.push(channel.payment_provider.name);
        }

        // If the current custom options don't yet have this payment method's name, add it
        if (!customOptions.paymentMethodName.includes(channel.payment_method.name)) {
            customOptions.paymentMethodName.push(channel.payment_method.name);
        }
    });

    // Format them like the schema options
    schema.payment_provider_name.options = customOptions.paymentProviderName.map(n => ({name: n, key: n}));
    schema.payment_method_name.options = customOptions.paymentMethodName.map(n => ({name: n, key: n}));

    // Return
    return schema;
};

export default getCustomizedFilterSchema;
